module.exports = __webpack_public_path__ + "media/npc_dota_hero_hoodwink.25bccb48.webm";